export type RegisterClickParams = {
  brand_name: string;
  cta_type: string;
  source: string;
};

const REGISTER_URL_BRANDS: Array<{ match: string; brand: string }> = [
  { match: 'ipay9aud.co', brand: 'iPay9vip' },
  { match: 'mrboom9.com', brand: 'MrBoom9' },
  { match: 'i9aud.net', brand: 'iPay9' },
  { match: 'ipay9.co', brand: 'iPay9' },
  { match: 'kingbet9.co', brand: 'Kingbet9' },
  { match: 'k9aus.net', brand: 'Kingbet9' },
  { match: 'bigpay77.co', brand: 'Bigpay77' },
  { match: 'me99office.co', brand: 'Me99' },
  { match: 'rolex9.net', brand: 'Rolex9' },
  { match: 'guccii9au.net', brand: 'Gucci9' },
  { match: 'mrbean9au.com', brand: 'MrBean9' },
  { match: 'pokepokemon9.com', brand: 'Spinaroo' },
  { match: 'winnie777.vip', brand: 'Winnie777' },
  { match: 'micky13.asia', brand: 'Micky9' },
  { match: 'bybid9.net', brand: 'Bybid9' },
  { match: 'queen13au.com', brand: 'Queen13' },
];

export function normalizeBrandLabel(label: string): string {
  return label
    .replace(/\s+Casino(\s+No Deposit|\s+Bonus Codes)?$/i, '')
    .trim();
}

export function getBrandFromRegisterUrl(url: string): string {
  try {
    const hostname = new URL(url).hostname.replace(/^www\./, '');
    const matched = REGISTER_URL_BRANDS.find(({ match }) => hostname.includes(match));
    return matched?.brand ?? 'Unknown';
  } catch {
    return 'Unknown';
  }
}

export function trackRegisterClick({ brand_name, cta_type, source }: RegisterClickParams) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'register_click', {
    brand_name,
    cta_type,
    source,
  });
}

export function handleRegisterClick(brandName: string, ctaType: string, source: string) {
  trackRegisterClick({
    brand_name: normalizeBrandLabel(brandName),
    cta_type: ctaType,
    source,
  });
}

export function handleRegisterUrlClick(url: string, ctaType: string, source: string) {
  handleRegisterClick(getBrandFromRegisterUrl(url), ctaType, source);
}

export function openRandomRegisterLink(urls: string[], ctaType: string, source: string) {
  const url = urls[Math.floor(Math.random() * urls.length)];
  const brandName = getBrandFromRegisterUrl(url);
  trackRegisterClick({ brand_name: brandName, cta_type: ctaType, source });
  window.open(url, '_blank', 'noopener,noreferrer');
}
